import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import About from './Screens/About.js';
import { Nav, Navbar } from 'react-bootstrap';
import Footer from './Components/Footer';
import Contact from './Screens/Contact.js';
import Articles from './Screens/Articles.js';
import ArticleDetail from './Screens/ArticleDetail.js';
import Simulator from './Screens/Simulator.js';
import DataPlataform from './Screens/DataPlataform.js';
import { ChevronRight } from 'lucide-react';

import { createRoot } from 'react-dom/client';
import Button from './Components/Button.js';
import TitleCard from './Components/TitleCard.js';
import Lottie from 'lottie-react';

import homeAnimation from './assets/animations/home.json';
import plataformaAnimation from './assets/animations/plataforma.json';
import sobreAnimation from './assets/animations/sobre.json';


import CustomAccordion from './Components/CustomAccordion';
import ScrollToTop from './Components/ScrollToTop.js';
import MunicipalRevenue from './Screens/DataPlataformScreens/MunicipalRevenue.js';
import MunicipalTransferRevenue from './Screens/DataPlataformScreens/MunicipalTransferRevenue.js';
import MunicipalNetCurrentRevenue from './Screens/DataPlataformScreens/MunicipalNetCurrentRevenue.js';
import MunicipalAnnualExpense from './Screens/DataPlataformScreens/MunicipalAnnualExpense.js';
import MunicipalFunctionExpense from './Screens/DataPlataformScreens/MunicipalFunctionExpense.js';

import StateRevenue from './Screens/DataPlataformScreens/StateRevenue.js';
import StateTransferRevenue from './Screens/DataPlataformScreens/StateTransferRevenue.js';
import StateNetCurrentRevenue from './Screens/DataPlataformScreens/StateNetCurrentRevenue.js';
import StateAnnualExpense from './Screens/DataPlataformScreens/StateAnnualExpense.js';
import StateFunctionExpense from './Screens/DataPlataformScreens/StateFunctionExpense.js';
import Dirbi from './Screens/DataPlataformScreens/Dirbi.js';
class App extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedTab: '',
            loading: false,
            navExpanded: false,
        };
    }

    handleClickAccessData = () => {
        // window.location.href = 'http://54.196.209.0/';      
    }

    setNavExpanded = (expanded) => {
        this.setState({ navExpanded: expanded });
    };

    closeNav = () => {
        this.setState({ navExpanded: false });
    };

    handleSelect = (selectedKey) => {
        this.setState({ selectedTab: selectedKey });
        this.closeNav();
    };

    openInNewTab = (link) => {
        window.open(link);
    };

    render() {
        const { selectedTab } = this.state;

        const isMobile = window.innerWidth <= 767;
        // const heightImg = isMobile ? 200 : 600;
        // const heightBiggerImg = isMobile ? 250 : 650;

        const currentPath = window.location.pathname.slice(1);

        return (

            <div>
                <div className="container container-center" >
                    <Navbar bg="white" expand="md" className='navbar'
                        expanded={this.state.navExpanded}
                        onToggle={this.setNavExpanded}>
                        <Navbar.Brand as={Link} to="/">
                            <img
                                src="/images/logo.png"
                                width="200"
                                // height="30"
                                className="d-inline-block align-top"
                                alt="Logo"
                            />
                        </Navbar.Brand>
                        {isMobile && (
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        )}
                        <Navbar.Collapse id="basic-navbar-nav" style={{ justifyContent: 'flex-end' }}>
                            <Nav className="mr-auto justify-content-between" onSelect={this.handleSelect} activekey={selectedTab}>
                                <div className='d-flex div-link'>
                                    <Nav.Link as={Link}
                                        to="/"
                                        eventKey="home"
                                        style={{ color: currentPath === 'home' || currentPath === '' ? '#4654A3' : '#3C3C3C', textDecoration: 'none', fontWeight: 'normal', fontSize: '14px' }}
                                        className='home-link'
                                    >
                                        Início
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/about"
                                        eventKey="about"
                                        style={{ color: currentPath === 'about' ? '#4654A3' : '#3C3C3C', textDecoration: 'none', fontWeight: 'normal', fontSize: '14px' }}
                                        className='nav-link'
                                    >
                                        Sobre a FiscalData
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/article"
                                        eventKey="article"
                                        style={{ color: currentPath === 'article' ? '#4654A3' : '#3C3C3C', textDecoration: 'none', fontWeight: 'normal', fontSize: '14px' }}
                                        className='nav-link'
                                    >
                                        Artigos
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/data-platform"
                                        eventKey="data-platform"
                                        style={{ color: currentPath === 'data-platform' ? '#4654A3' : '#3C3C3C', textDecoration: 'none', fontWeight: 'normal', fontSize: '14px' }}
                                        className='nav-link'
                                    >
                                        Plataforma de Dados
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/simulator"
                                        eventKey="simulator"
                                        style={{ color: currentPath === 'simulator' ? '#4654A3' : '#3C3C3C', textDecoration: 'none', fontWeight: 'normal', fontSize: '14px' }}
                                        className='nav-link'
                                    >
                                        Simulador da Renda
                                    </Nav.Link>
                                    <Nav.Link
                                        as={Link}
                                        to="/contact"
                                        eventKey="contact"
                                        style={{ color: currentPath === 'contact' ? '#4654A3' : '#3C3C3C', textDecoration: 'none', fontWeight: 'normal', fontSize: '14px' }}
                                        className='nav-link'
                                    >
                                        Contato
                                    </Nav.Link>
                                    {/* {
                                        isMobile ?
                                            <Nav.Link
                                                href="/contact"
                                                style={{ color: currentPath === 'contact' ? '#4654A3' : '#3C3C3C', textDecoration: 'none', fontWeight: 'normal', fontSize: '14px' }}
                                                className='nav-link'
                                            >
                                                Contato
                                            </Nav.Link>
                                            : null
                                    } */}

                                </div>
                                {/* {
                                    isMobile ?
                                        null
                                        :
                                        <div className='contact-block'>
                                            <BsPersonCircle style={{ color: 'white', fontSize: '24px' }} />

                                            <Nav.Link href="/contact" style={{ color: 'white', textDecoration: 'none' }}>Contato</Nav.Link>
                                        </div>
                                } */}


                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </div>

                <Routes>
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/article" element={<Articles />} />
                    {/* <Route path="/monitor" element={<Monitor />} /> */}
                    <Route path="/article-details/:id" element={<ArticleDetail />} />
                    <Route path="/simulator" element={<Simulator />} />
                    <Route path="/data-platform" element={<DataPlataform />} />
                    <Route path="/data-platform/municipal-revenue" element={<MunicipalRevenue />} />
                    <Route path="/data-platform/municipal-transfer-revenue" element={<MunicipalTransferRevenue />} />
                    <Route path="/data-platform/municipal-net-current-revenue" element={<MunicipalNetCurrentRevenue />} />
                    <Route path="/data-platform/municipal-annual-expense" element={<MunicipalAnnualExpense />} />
                    <Route path="/data-platform/municipal-function-expense" element={<MunicipalFunctionExpense />} />

                    <Route path="/data-platform/state-revenue" element={<StateRevenue />} />
                    <Route path="/data-platform/state-transfer-revenue" element={<StateTransferRevenue />} />
                    <Route path="/data-platform/state-net-current-revenue" element={<StateNetCurrentRevenue />} />
                    <Route path="/data-platform/state-annual-expense" element={<StateAnnualExpense />} />
                    <Route path="/data-platform/state-function-expense" element={<StateFunctionExpense />} />
                    <Route path="/data-platform/dirbi" element={<Dirbi />} />

                    {/*<Route path="/article-create" element={<ArticleCreate />} />} */}
                    <Route path="/" element={<div className="container container-inner">
                        {/* <h1 style={{ textAlign: 'center' }}>Hello, React!</h1>     */}
                        {/* <div className='text-and-img-block'>
                            <div className='access-data-text-block'>
                                <span className='title-text'>Acesso à séries de dados fiscais públicos consistentes</span>
                                <span className='subtitle-text mt-3'>
                                    Somos movidos pelo esforço de pessoas que acreditam no poder dos dados abertos e de qualidade.
                                </span>
                                <Link to="/monitor" className='people-block' style={{ marginBottom: '29px', textDecoration: 'none', color: 'inherit' }}>
                                    <span className='subtitle-text access-data-button' style={{ zIndex: 1 }}>
                                        acesse nossos dados
                                    </span>
                                </Link>
                            </div>
                            {
                                isMobile ?
                                    null :

                                    <div className='d-flex flex-row justify-content-end' style={{ marginRight: '1px', display: 'none' }}>
                                        <img
                                            src="/images/Pag1 Img1.png"
                                            // width="90"
                                            height={heightImg}
                                            className="d-inline-block align-top background-img-1-1"
                                            alt="img"
                                        />
                                        <img
                                            src="/images/Quadrado 1 pag 1.png"
                                            // width="90"
                                            height={heightImg}
                                            className="d-inline-block align-top background-img-1"
                                            alt="img"
                                        />
                                    </div>
                            }

                        </div> */}

                        <div className='home-first-block home-first-block-padding' style={{
                            backgroundImage: `
                                linear-gradient(to bottom, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0) 15%),
                                linear-gradient(to bottom, rgba(255,255,255,0) 80%, #fff 100%),
                                url('/images/home/background.svg')
                            `,
                        }}>
                            <div className='home-first-block-left' style={{
                                width: '75%',
                                position: 'relative',
                                zIndex: 2
                            }}>
                                <TitleCard
                                    iconLeft={<img
                                        src="/images/icons/Buildings.svg"
                                        width="18"
                                        alt="Buildings"
                                    />}
                                    label='QUALIDADE E CONFIANÇA'

                                />
                                <span className='title-text title-text-xl'>
                                    Dados fiscais <br /> públicos acessíveis <br /> e confiáveis
                                </span>
                                <span style={{ marginBottom: '30px', color: 'gray' }}>
                                    Acreditamos no poder dos dados abertos para transformar informações <br /> em conhecimento.
                                </span>
                                <Button
                                    label="Acesse aqui"
                                    variant="primary"
                                    iconRight={<ChevronRight />}
                                    onClick={() => this.props.navigate('/data-platform')}
                                />
                            </div>

                            <div className='first-lottie'>
                                <Lottie animationData={homeAnimation} loop={true} />
                            </div>

                        </div>
                        <div className='home-first-block home-blocks banners-outer-block'>
                            <div className='banners-block'>
                                <div>
                                    <img
                                        src="/images/icons/base_dados.svg"
                                        width="100"
                                        alt="Base de Dados"
                                    />
                                    <span style={{ fontWeight: 'bold', fontSize: '24px', marginTop: '25px' }}>Base de <br /> Dados</span>
                                    <span style={{ marginBottom: '30px', color: 'gray', marginTop: '10px' }}>Desenvolvimento de ambientes <br /> com informações de finanças <br /> públicas e socioeconômicas.</span>
                                </div>
                                <div className='line'></div>
                                <div>
                                    <img
                                        src="/images/icons/pesquisa_analises.svg"
                                        width="100"
                                        alt="Pesquisas e Análises"
                                    />
                                    <span style={{ fontWeight: 'bold', fontSize: '24px', marginTop: '25px' }}>Pesquisas e <br /> Análises</span>
                                    <span style={{ marginBottom: '30px', color: 'gray', marginTop: '10px' }}>Produção de estudos <br /> econômicos, notas e boletins <br /> técnicos.</span>
                                </div>
                                <div className='line'></div>
                                <div>
                                    <img
                                        src="/images/icons/modelagem_economica.svg"
                                        width="100"
                                        alt="Modelagem Econômica"
                                    />
                                    <span style={{ fontWeight: 'bold', fontSize: '24px', marginTop: '25px' }}>Modelagem <br /> Econômica</span>
                                    <span style={{ marginBottom: '30px', color: 'gray', marginTop: '10px' }}>Construção de modelos <br /> econômicos e econométricos <br /> para análises estratégicas.</span>
                                </div>
                                <div className='line'></div>
                                <div>
                                    <img
                                        src="/images/icons/solucoes_tecnologicas.svg"
                                        width="100"
                                        alt="Soluções Tecnológicas"
                                    />
                                    <span style={{ fontWeight: 'bold', fontSize: '24px', marginTop: '25px' }}>Soluções <br /> Tecnológicas</span>
                                    <span style={{ marginBottom: '30px', color: 'gray', marginTop: '10px' }}>Desenvlvimento de aplicações <br /> para disponibilização de <br /> informações na web.</span>
                                </div>
                            </div>
                        </div>
                        <div
                            className='home-first-block home-blocks'
                            style={{
                                backgroundColor: '#FAFAFA',
                                display: 'flex',
                                position: 'relative',
                                alignItems: 'center',
                                minHeight: '400px'
                            }}
                        >
                            <div
                                className='home-first-block-left'
                                style={{
                                    width: '60%',
                                    position: 'relative',
                                    zIndex: 2
                                }}
                            >
                                <TitleCard
                                    iconLeft={<img src="/images/icons/conheca_fiscaldata.svg" width="18" alt="Conheça a FiscalData" />}
                                    label='CONHEÇA A FISCALDATA'
                                />
                                <span className='title-text' style={{ marginTop: '45px' }}>
                                    Unindo finanças públicas, <br /> economia e tecnologia
                                </span>
                                <span style={{ marginBottom: '30px', color: 'gray' }}>
                                    Facilitamos o acesso à informação e promovemos um debate <br /> transparente sobre politicas públicas;
                                </span>
                                <Button
                                    label="Saiba mais"
                                    variant="primary"
                                    iconRight={<ChevronRight />}
                                    onClick={() => this.props.navigate('/about')}
                                />
                            </div>
                            <div
                                style={{
                                    width: '40%',
                                    minWidth: '250px',
                                    maxWidth: '500px',
                                    pointerEvents: 'none'
                                }}
                            >
                                <Lottie animationData={sobreAnimation} loop={true} />
                            </div>
                        </div>
                        <div className='home-first-block home-plataform-block' style={{ justifyContent: 'center' }}>
                            <div className='home-first-block-center' style={{ paddingTop: '20px' }}>
                                <TitleCard
                                    iconLeft={<img
                                        src="/images/icons/escolha_certa.svg"
                                        width="18"
                                        alt="Escolha Certa"
                                    />}
                                    label='ESCOLHA CERTA'
                                />
                                <span className='title-text' style={{ marginTop: '30px', marginBottom: '30px' }}>
                                    Plataforma de Dados FiscalData
                                </span>
                                <div className='lottie-plataform'>
                                    <Lottie animationData={plataformaAnimation} loop={true} />
                                </div>
                                <Button
                                    label="Acesse a Plataforma de Dados"
                                    variant="primary"
                                    iconRight={<ChevronRight />}
                                    onClick={() => this.props.navigate('/data-platform')}
                                />
                            </div>
                        </div>
                        <div className='home-first-block home-blocks' style={{ backgroundColor: '#FAFAFA' }}>
                            <img
                                src="/images/home/simulador.svg"
                                alt="simulador"
                                className='img-svg'
                            />
                            <div className='home-first-block-left' style={{ marginRight: 0 }}>
                                <TitleCard
                                    iconLeft={<img
                                        src="/images/icons/simulador.svg"
                                        width="18"
                                        alt="Simulador da Renda"
                                    />}
                                    label='SIMULADOR DE RENDA'
                                />
                                <span className='title-text'>
                                    Você está entre os mais ricos do Brasil?
                                </span>
                                <span style={{ marginBottom: '30px', color: 'gray' }}>
                                    Quer saber se você está entre os 10%, 5% ou 1% mais ricos do <br /> Brasil?
                                    <br />
                                    <br />
                                    Acesse a plataforma contruída pela equipe da FiscalData e <br /> descubra com que ponto da pirâmide social você está.
                                </span>
                                {/* <Button
                                    label="Saiba Mais"
                                    variant="primary"
                                    iconRight={<ChevronRight />}
                                    onClick={() => this.props.navigate('/simulator')}
                                /> */}
                            </div>

                        </div>
                        <div className='home-first-block home-blocks' style={{ backgroundColor: '#fff' }}>
                            <div className='home-first-block-left'>
                                <TitleCard
                                    iconLeft={<img
                                        src="/images/icons/conteudo.svg"
                                        width="18"
                                        alt="Conteúdo"
                                    />}
                                    label='CONTEÚDO'
                                />
                                <span className='title-text'>
                                    Artigos e Notas Técnicas
                                </span>
                                <span style={{ marginBottom: '30px', color: 'gray' }}>
                                    Aprofunde-se em análises, estudos e conteúdos produzidos <br /> por especialistas em finanças públicas e economia. Aqui você <br /> encontra reflexões baseadas em dados, modelos técnicos e <br /> temas que impactam a gestão e o debate público no Brasil.
                                </span>
                                <Button
                                    label="Saiba Mais"
                                    variant="primary"
                                    iconRight={<ChevronRight />}
                                    onClick={() => this.props.navigate('/article')}
                                />
                            </div>
                            <img
                                src="/images/home/conteudo.svg"
                                alt="conteúdo"
                                className='img-svg'
                            />
                        </div>
                        <div className='home-first-block home-blocks' style={{ backgroundColor: '#FAFAFA' }}>
                            <div className='home-first-block-left'>
                                <TitleCard
                                    iconLeft={<img
                                        src="/images/icons/perguntas_frequentes.svg"
                                        width="18"
                                        alt="Perguntas Frequentes"
                                    />}
                                    label='PERGUNTAS FREQUENTES'
                                />
                                <span className='title-text'>
                                    O que você deseja saber <br /> sobre a FiscalData?
                                </span>
                                {/* <Button
                                    label="Mais perguntas frequentes"
                                    variant="primary"
                                    iconRight={<ChevronRight/>}
                                    onClick={() => console.log('Perguntas Frequentes')}                                        
                                />                               */}
                            </div>
                            <div className='searchs-block'>
                                <div>
                                    <CustomAccordion title="O que é a plataforma?">
                                        A plataforma oferece dados fiscais públicos de forma acessível, confiável e organizada.
                                    </CustomAccordion>
                                </div>
                                <div style={{ marginTop: '30px' }}>
                                    <CustomAccordion title="Quais informações posso encontrar na FiscalData?">
                                        A plataforma oferece dados fiscais públicos de forma acessível, confiável e organizada.
                                    </CustomAccordion>
                                </div>
                                <div style={{ marginTop: '30px' }}>
                                    <CustomAccordion title="Quem pode utilizar os dados da FiscalData?">
                                        A plataforma oferece dados fiscais públicos de forma acessível, confiável e organizada.
                                    </CustomAccordion>
                                </div>
                                <div style={{ marginTop: '30px' }}>
                                    <CustomAccordion title="A FiscalData é uma instituição governamental?">
                                        A plataforma oferece dados fiscais públicos de forma acessível, confiável e organizada.
                                    </CustomAccordion>
                                </div>
                            </div>
                        </div>
                        <div className='home-first-block home-blocks' style={{ backgroundColor: '#fff', width: '100%', justifyContent: 'center' }}>
                            <div className='home-first-block-center' style={{ width: '100%' }}>
                                <TitleCard
                                    iconLeft={<img
                                        src="/images/icons/institucional.svg"
                                        width="18"
                                        alt="Institucional"
                                    />}
                                    label='INSTITUCIONAL'
                                />
                                <span className='title-text'>
                                    Parceiros FiscalData
                                </span>
                                <div className='partners-block'>

                                    <div className='support-img-block'>
                                        <img
                                            src="/images/ccif.png"
                                            // width="90"
                                            height="60"
                                            className="d-inline-block align-top"
                                            alt="img"
                                            onClick={() => window.open("https://ccif.com.br/", "_blank")}
                                        />
                                    </div>

                                    <div className='support-img-block'>
                                        <img
                                            src="/images/febrafite.svg"
                                            // width="90"
                                            height="90"
                                            className="d-inline-block align-top"
                                            alt="img"
                                            onClick={() => window.open("https://www.febrafite.org.br/", "_blank")}
                                        />
                                    </div>

                                    <div className='support-img-block'>
                                        <img
                                            src="/images/fenafim.jpeg"
                                            // width="90"
                                            height="60"
                                            className="d-inline-block align-top"
                                            alt="img"
                                            onClick={() => window.open("https://www.fenafim.org.br/site/", "_blank")}
                                        />
                                    </div>




                                    <div className='support-img-block'>
                                        <img
                                            src="/images/sindifisco.png"
                                            // width="90"
                                            height="60"
                                            className="d-inline-block align-top"
                                            alt="img"
                                            onClick={() => window.open("https://www.sindifisconacional.org.br/", "_blank")}
                                        />
                                    </div>



                                    <div className='support-img-block'>
                                        <img
                                            src="/images/mais_progresso.jpeg"
                                            // width="90"
                                            height="130"
                                            className="d-inline-block align-top"
                                            alt="img"
                                            onClick={() => window.open("https://maisprogresso.org/", "_blank")}
                                        />
                                    </div>

                                    <div className='support-img-block'>
                                        <img
                                            src="/images/oxfam.jpeg"
                                            // width="90"
                                            height="70"
                                            className="d-inline-block align-top"
                                            alt="img"
                                            onClick={() => window.open("https://www.oxfam.org.br/", "_blank")}
                                        />
                                    </div>

                                </div>


                            </div>
                        </div>

                        <Footer selectedTab={this.state.selectedTab} style={{ marginTop: '-135px' }} />
                    </div>} />
                </Routes>
            </div>


        );
    }
}

function AppWithNavigate(props) {
    const navigate = useNavigate();
    return <App {...props} navigate={navigate} />;
}

const root = createRoot(document.getElementById('root'));
root.render(
    <Router>
        <ScrollToTop />
        <AppWithNavigate />
    </Router>
);
